import React, { PureComponent } from 'react';

import cxHelpers from 'util/className';

@cxHelpers('PoweredByHomebaseBadge')
export default class ApplyLink extends PureComponent {
  render() {
    return (
      <div className={this.cx()}>
        <a href="https://joinhomebase.com" target="_blank">
          <img
            src={require('theme/images/powered-by-homebase.png')}
            alt="Powered by Homebase"
          />
        </a>
      </div>
    );
  }
}
